import { render } from "./form-section.vue?vue&type=template&id=601ef894&scoped=true&ts=true"
import script from "./form-section.vue?vue&type=script&lang=ts"
export * from "./form-section.vue?vue&type=script&lang=ts"

import "./form-section.vue?vue&type=style&index=0&id=601ef894&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-601ef894"]])

export default __exports__